import Button from '@carvana/ds-button';
import { CheckCircleSpot } from '@carvana/ds-icons';
import { icon } from '@carvana/ds-styles';
import React, { useState } from 'react';
import styles from './we-have-everything.module.css';

interface WeHaveEverythingProps {
  onContinue: () => void;
}

const WeHaveEverything: React.FC<WeHaveEverythingProps> = ({ onContinue }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = () => {
    setIsLoading(true);
    onContinue();
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <CheckCircleSpot size={56} color={icon.primary} />
        <p className={styles.message}>You&apos;re all set!</p>
      </div>
      <Button
        variant="primary"
        size="md"
        className={styles.cta}
        width="100%"
        onClick={handleClick}
        isLoading={isLoading}
        data-analytics-id="verification-we-have-everything-continue"
      >
        Continue
      </Button>
    </div>
  );
};

export default WeHaveEverything;
